import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

const Hero = () => {
  const [currentText, setCurrentText] = useState(0);
  const texts = ['Plataforma Integrada', 'CRM', 'ERP'];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentText((prev) => (prev + 1) % texts.length);
    }, 3000); // Cambia cada 3 segundos

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="relative min-h-screen flex items-center justify-center bg-black overflow-hidden">
      {/* Video background placeholder - Verkada style */}
      <div className="absolute inset-0 bg-gradient-to-b from-black via-gray-900 to-black opacity-90"></div>
      
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-32 relative z-10">
        <div className="max-w-5xl mx-auto text-center">
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold mb-8 leading-tight text-white">
            <span 
              key={currentText}
              className="inline-block text-green-500 animate-fade-in"
            >
              {texts[currentText]}
            </span>
            {' '}para la gestión de tu negocio
          </h1>
          
          <p className="text-xl sm:text-2xl text-gray-300 mb-12 max-w-4xl mx-auto leading-relaxed font-light">
            La plataforma integrada de gestión para empresas en <strong className="text-white font-semibold">Latinoamérica y España</strong>. Todos tus productos y servicios en la nube, accesibles desde cualquier lugar en cualquier dispositivo.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-16">
            <Button 
              size="lg" 
              className="bg-green-600 hover:bg-green-700 text-white px-10 py-7 text-base rounded font-semibold transition-all duration-200"
              onClick={() => window.location.href = '/demo'}
            >
              Iniciar Prueba Gratuita de 30 Días
            </Button>
            <Button 
              size="lg" 
              variant="outline"
              className="border-2 border-white text-white hover:bg-white hover:text-black px-10 py-7 text-base rounded font-semibold transition-all duration-200"
              onClick={() => window.location.href = '/demo'}
            >
              Ver Demo en Vivo
            </Button>
          </div>

          {/* Scroll indicator - Verkada style */}
          <div className="flex flex-col items-center gap-2 text-gray-400 animate-bounce">
            <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
            </svg>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;